import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63fb81f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Calldrip Api", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Stel url in Voor", -1))
const _hoisted_3 = { style: {"table-layout":"fixed","margin-left":"auto","margin-right":"auto","width":"70%"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", {
    span: "1",
    style: {"width":"10%"}
  }),
  /*#__PURE__*/_createElementVNode("col", {
    span: "1",
    style: {"width":"90%"}
  })
], -1))
const _hoisted_5 = { align: "right" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "URL start gesprek: ", -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "URL eind gesprek: ", -1))
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "OrganizationID: ", -1))
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Status: ", -1))
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "UserID: ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Endpoints", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" REST POST een ADF xml → "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://mockservices.vijzelmolen.nl/api/Calldrip/SendADF" }, "https://mockservices.vijzelmolen.nl/api/Calldrip/SendADF")
], -1))
const _hoisted_18 = { class: "message" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", { style: {"height":"200px"} }, [
  /*#__PURE__*/_createElementVNode("col", {
    span: "1",
    style: {"width":"10%"}
  }),
  /*#__PURE__*/_createElementVNode("col", {
    span: "1",
    style: {"width":"20%"}
  }),
  /*#__PURE__*/_createElementVNode("col", {
    span: "1",
    style: {"width":"70%"}
  })
], -1))
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { align: "left" }
const _hoisted_25 = { class: "fields" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "apikey:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "apiuser:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "messageid:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("td", null, [
        _createElementVNode("button", {
          class: "button small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setEnvironmentUrl('http://localhost:9029')))
        }, " Localhost "),
        _createElementVNode("button", {
          class: "button small",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setEnvironmentUrl('https://calldrip.lef-test.vijzelmolen.nl')))
        }, " LEF-test "),
        _createElementVNode("button", {
          class: "button small",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (
          _ctx.setEnvironmentUrl('https://calldrip.lef.max-test.vijzelmolen.nl')
        ))
        }, " MAX-test "),
        _createElementVNode("button", {
          class: "button small",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (
          _ctx.setEnvironmentUrl('https://calldrip.lef-staging.vijzelmolen.nl')
        ))
        }, " Staging ")
      ]),
      _createElementVNode("td", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.start) = $event)),
            placeholder: ".../v1/feedback/startcall"
          }, null, 512), [
            [_vModelText, _ctx.start]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.end) = $event)),
            placeholder: ".../v1/feedback/endcall"
          }, null, 512), [
            [_vModelText, _ctx.end]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.organizationId) = $event)),
            placeholder: ""
          }, null, 512), [
            [_vModelText, _ctx.organizationId]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.status) = $event)),
            placeholder: ""
          }, null, 512), [
            [_vModelText, _ctx.status]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.userID) = $event)),
            placeholder: ""
          }, null, 512), [
            [_vModelText, this.userID]
          ])
        ])
      ])
    ]),
    _hoisted_16,
    _hoisted_17,
    _createElementVNode("button", {
      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.clearData && _ctx.clearData(...args)))
    }, "Clear"),
    _createElementVNode("p", null, _toDisplayString(this.response), 1),
    _createElementVNode("ul", _hoisted_18, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createElementVNode("table", null, [
            _hoisted_19,
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  class: "button",
                  onClick: ($event: any) => (_ctx.sendFeedBack(msg.MessageId, 'talking'))
                }, "Start gesprek", 8, _hoisted_20),
                _createElementVNode("button", {
                  class: "button",
                  onClick: ($event: any) => (_ctx.sendFeedBack(msg.MessageId, 'nietbereikt'))
                }, "Niet bereikt", 8, _hoisted_21),
                _createElementVNode("button", {
                  class: "button",
                  onClick: ($event: any) => (_ctx.sendFeedBack(msg.MessageId, 'answered'))
                }, " Eind gesprek (Answered) ", 8, _hoisted_22),
                _createElementVNode("button", {
                  class: "button",
                  onClick: ($event: any) => (_ctx.sendFeedBack(msg.MessageId, 'busy'))
                }, " Eind gesprek (Busy) ", 8, _hoisted_23)
              ]),
              _createElementVNode("td", _hoisted_24, [
                _createElementVNode("ul", _hoisted_25, [
                  _createElementVNode("li", null, [
                    _createElementVNode("b", null, _toDisplayString(msg.ReceivedTime.split("T")[0]), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("b", null, _toDisplayString(msg.ReceivedTime.split("T")[1].split(".")[0]), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_26,
                    _createTextVNode(" " + _toDisplayString(msg.apikey), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_27,
                    _createTextVNode(" " + _toDisplayString(msg.apiuser), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_28,
                    _createTextVNode(" " + _toDisplayString(msg.MessageId), 1)
                  ])
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("samp", null, _toDisplayString(msg.xml.trim()), 1)
              ])
            ])
          ]),
          _hoisted_29
        ]))
      }), 128))
    ])
  ], 64))
}